import { Component, EventEmitter, Input, Output } from "@angular/core";

export type ActionButton = {
    id: string;
    label: string;
} & (
    {
        type: 'button';
    } | {
        type: 'anchor',
        target: '_blank' | '_self';
        href: string;
    }
);

export interface ActionButtonClick {
    event: Event;
    button: ActionButton;
}

@Component({
    selector: 'action-buttons',
    templateUrl: './action-buttons.component.html'
})
export class ActionButtonsComponent {
    @Input()
    public buttonsData: ActionButton[] = [];

    @Input()
    public styleClass: string = '';

    @Output()
    public readonly buttonClick = new EventEmitter<ActionButtonClick>();

    public onButtonClick(event: Event, button: ActionButton): void {
        this.buttonClick.emit({ event, button });
    }
}
